import versionData from './version.generated.json';

export const { version, shortCommitHash } = versionData;
